/* global global */
import { isServerSideRendering } from "@/ssr-utils/ssr-env";

export default (isServerSideRendering ? global.globals : window.globals) || {};
